import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
	name: "auth",
	initialState: {
		user: null,
		accessToken: null,
	},
	reducers: {
		setUserAuth: (state, action) => {
			state.user = action.payload.user;
			state.accessToken = action.payload.token;
		},
	},
});

export const { setUserAuth } = authSlice.actions;
export default authSlice.reducer;
